import {useForm} from "react-hook-form";
import React, {useContext, useEffect, useState} from "react";
import {Paper} from "@mui/material";
import strings from "../../../localization";
import DrawerContext from "../../../Context/DrawerContext";
import LinearProgress from '@mui/material/LinearProgress';
import SnackbarContext from "../../../Context/SnackbarContext";
import {
    addProductServiceCategory, getProductServiceCategoryList
} from "../../../Services/Product/ProductServiceCategoryService";
import ProductServiceCategoryForm from "../../../Components/Forms/Pages/Product/ProductServiceCategoryForm";

const formRules = {
    'name': {required: true}, 'publicName': {required: true}
}

const AddProductServiceCategory = (props) => {

    const {setDrawerTitle} = useContext(DrawerContext);
    const { showMessage } = useContext(SnackbarContext);
    const form = useForm();
    const {data, control, handleSubmit, getValues, setValue, formState: {errors}} = form;
    const [showLoader, setShowLoader] = useState(false);
    const [productServiceCategories, setProductServiceCategories] = useState(0);


    useEffect(() => {
        setDrawerTitle(strings.pages.product.productServiceCategory.addProductServiceCategory.pageTitle);
    });

    useEffect(()=>{
        fetchParent();
    },[])

    const fetchParent = (term = "") => {
        getProductServiceCategoryList({term}).then((response) => {
            if (!response || !response.ok) {
                return;
            }
            setProductServiceCategories(response.data.result);
        });
    }

    const onSubmit = (data) => {

        setShowLoader(true);

        addProductServiceCategory(data).then(response => {
            setShowLoader(false);

            if (!response || !response.ok) {
                showMessage(strings.commonMessages.errorAdding, 'error');
                props.onFinish();
                return;
            }

            showMessage(strings.commonMessages.addingSuccessful, 'success');
            props.onFinish(response.data.entity);
        });
    }

    const onCancel = () => {
        props.onCancel();
    }

    return <div className='drawer-form'>
        <Paper className='paper'>
            {
                showLoader &&
                <LinearProgress/>
            }
            <ProductServiceCategoryForm
                formRules={formRules}
                values={getValues()}
                setValue={setValue}
                parent={productServiceCategories}
                errors={errors} data={data} form={form} control={control}
                onParentChangeFilter={fetchParent}
                onSubmit={handleSubmit(onSubmit)} onCancel={() => onCancel()}/>
        </Paper>
    </div>
}

export default AddProductServiceCategory;